import * as ActionsTypes from "../../../../common/constants/stateConstants";

/*---------------------------------------------GET-CONSULTATION-SOUSCRIPTIONS-LIST-------------------------------------------------*/
export const getConsultationSouscriptionsListAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_SOUSCRIPTIONS_LIST,
    payload,
  };
};

export const getConsultationSouscriptionsListSuccessAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_SOUSCRIPTIONS_LIST_SUCCESS,
    payload,
  };
};

export const getConsultationSouscriptionsListFailAction = (payload) => {
  return {
    type: ActionsTypes.GET_CONSULTATION_SOUSCRIPTIONS_LIST_FAIL,
    payload,
  };
};

/*------------------------------------------GENERATION-BON-COMMANDE-SOUSCRIPTION---------------------*/
export const generationBonCommandeSouscription = (payload) => {
  return {
    type: ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION,
    payload,
  };
};
export const generationBonCommandeSouscriptionSuccess = (payload) => {
  return {
    type: ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION_SUCCESS,
    payload,
  };
};
export const generationBonCommandeSouscriptionFail = (payload) => {
  return {
    type: ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION_FAIL,
    payload,
  };
};
export const generationBonCommandeSouscriptionReinitialization = (payload) => {
  return {
    type: ActionsTypes.GENERATION_BON_COMMANDE_SOUSCRIPTION_REINITIALIZATION,
    payload,
  };
};
/*------------------------------------------Excel---------------------*/
export const excelExport = (payload) => {
  return {
    type: ActionsTypes.GENERAL_EXCEL_SOUSCRIPTION_EXPORT,
    payload,
  };
};
export const printSuccess = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_SOUSCRIPTION_SUCCESS,
    payload,
  };
};
export const printFail = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_SOUSCRIPTION_FAIL,
    payload,
  };
};
export const printReinitialization = (payload) => {
  return {
    type: ActionsTypes.GENERAL_PRINT_SOUSCRIPTION_REINITIALIZATION,
    payload,
  };
};
